export enum EnumTipoBalance {
  PVB = 1,
  GNL,
  AASS
}
